/**
 * <zh/> 获取元素的 zIndex
 * <en/> Get the zIndex of the element
 * @param datum - <zh/> 元素数据 | <en/> element data
 * @returns - <zh/> zIndex | <en/> zIndex
 */
export function getZIndexOf(datum) {
    var _a;
    return ((_a = datum === null || datum === void 0 ? void 0 : datum.style) === null || _a === void 0 ? void 0 : _a.zIndex) || 0;
}
//# sourceMappingURL=z-index.js.map